<template>
  <div class="vs-col mb-4 radial_size">
    <apexchart
      type="radialBar"
      height="250"
      :options="chartParams.chartOptions"
      :series="chartParams.series"
    />
    <h4
      class="txt_center"
      :class="{
        txt_high: score >= 90,
        txt_medium: score >= 50 && score <= 89,
        txt_low: score <= 49
      }"
    >
      {{ parseFloat(loadingTime).toFixed(1) }} s
    </h4>
  </div>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "SimpleRadial",
	props: {
		chartParams: Object,
		name: String,
		loadingTime: Number,
		score: Number
	},
	mixins: [utilsMixin]
};
</script>

<style scoped>
.txt_center {
  text-align: center;
}

.txt_low {
  color: #ff4e42;
}

.txt_medium {
  color: #ffa400;
}

.txt_high {
  color: #20e647;
}

.radial_size {
  min-width: 200px;
}
</style>
